import React from 'react';
import styles from './Confirmation.module.scss';

interface Props {
	text: string;
	imageSource?: string;
	children?: React.ReactElement | React.ReactElement[];
}

const Confirmation: React.FC<Props> = ({ text, imageSource, children }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.greyBox}>
				{imageSource && <img src={imageSource} alt='checked' />}
				<p>{text}</p>
			</div>
			<div className={styles.whiteBox}>{children}</div>
		</div>
	);
};

export default Confirmation;
